export const COLOR_PRIMARY = '#F29C5E';
